import { useState } from "react";

import { api, type Utilisateur } from "./api";

export default function Connexion({
  surConnexion,
}: {
  surConnexion: (utilisateur: Utilisateur) => void;
}) {
  const [identifiant, setIdentifiant] = useState("");
  const [motDePasse, setMotDePasse] = useState("");
  const [erreur, setErreur] = useState<string | null>(null);
  const [encours, setEncours] = useState(false);

  const soumettre = async (evenement: React.FormEvent) => {
    evenement.preventDefault();
    setEncours(true);
    setErreur(null);
    try {
      surConnexion(await api.ouvrirSession(identifiant, motDePasse));
    } catch (e) {
      setErreur((e as Error).message);
      setMotDePasse("");
    } finally {
      setEncours(false);
    }
  };

  return (
    <main className="connexion">
      <h1>Atelier</h1>
      <p className="sous-titre">
        Évaluation par compétences : de l'énoncé LaTeX au feedback individuel
      </p>

      <form onSubmit={soumettre}>
        <label>
          <span>Identifiant</span>
          <input
            value={identifiant}
            onChange={(e) => setIdentifiant(e.target.value)}
            autoComplete="username"
            autoFocus
            required
          />
        </label>
        <label>
          <span>Mot de passe</span>
          <input
            type="password"
            value={motDePasse}
            onChange={(e) => setMotDePasse(e.target.value)}
            autoComplete="current-password"
            required
          />
        </label>

        {erreur && <p className="erreur">{erreur}</p>}

        <button type="submit" disabled={encours}>
          {encours ? "Connexion…" : "Se connecter"}
        </button>
      </form>

      <p className="aide">
        Pas encore de compte ? Il s'en crée un depuis le serveur :{" "}
        <code>python3 backend/scripts/creer_compte.py</code>. Aucune inscription
        n'est ouverte depuis cette page — l'application ne s'adresse qu'aux
        professeurs de l'établissement.
      </p>
    </main>
  );
}
